import { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";


import TableAHSF from "../../../Components/TableAHSF";
import PopupAHSF from "../../../Components/PopupAHSF";
import loadConfig from "../../../Services/Api/ApiServices";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import { DeleteSubObjectives } from "../../../Redux/Reducers/ReportStage/SubObjectives";
import AddEditSubObjective from "../SubObjectives/AddEditSubObjective";

const SubObjectivesForStage = (props) => {
//   const { reportId, reportStageId } = useParams();

  const [jsonData, setJsonData] = useState({});
  const dispatch = useDispatch();
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [subObjectivesId, setsubObjectivesId] = useState(null);
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
    };
  });
  const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);
  const ApplicationInformation = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );
  const shouldDisableFields = !(
    ActiveRound == ApplicationInformation?.aI_RoundYearId &&
    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit &&
    window.location.href.includes("manager") == false
  );
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestAccessor = [
    {
      KeyName: "subObjectivesName",
      ShowStatus: true,
      NmaeColumn: "الهدف الفرعي",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  const M_ApplicationsBtns = [
    // {
    //   Click: async (e) => {
    //     setsubObjectivesId(e.target.value);
    //     console.log(e.target.value, "sssssssssssss");
    //     setPopUpBodyOPjectDataStatus(true);
    //   },
    //   content: "",
    //   className: "bi bi-view-list",

    //   id: "editBtn",
    //   title: "عرض",
    //   ShowStatus: true,
    // },
    
    
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: (
      <div>{<AddEditSubObjective reportId={props.reportId} />}</div>
    ),
    title: "الاهداف الفرعية",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  const closePopUpBodyOPjectData = () => {
    setPopUpBodyOPjectDataStatus(false);
  };

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },
    componentBody: (
      <div>
        <AddEditSubObjective
          reportId={props.reportId}
          subObjectivesId={subObjectivesId}
          canEdit="edit"
        />
      </div>
    ),
    title: "الاهداف الفرعية",
    maxWidth: "500px",
    maxHeight: "500px",
  };
  return (
    <>

    {
      true?<>
       <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"subObjectivesForStageId"}
        valueButtonAction={"subObjectivesForStageId"}
        URL={`api/SubObjectivesForStage/GetListSubObjectivesForStage`}
        UrlBody={{
          reportStageId: props.reportStageId,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        // tableBtn={!shouldDisableFields}
        tableBtn={false}
        sortTable={false}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={props.checkBoks}
        uniqeKeyNameRedux={"subObjectivesForStage"}
        nameColumAction=""
        total={false}
        uniqeKeyName={"subObjectivesForStageId"}

        arrayButton={M_ApplicationsBtns}
        ArrayNameDataColum={[]}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
            isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
            title={popUpBodyOPjectData.title}
            componentBody={popUpBodyOPjectData.componentBody}
            maxWidth={popUpBodyOPjectData.maxWidth}
            maxHeight={popUpBodyOPjectData.maxHeight}
          />
        }
      />
      </>:<></>
    }
     
    </>
  );
};

export default SubObjectivesForStage;
